export interface IProductEntityCharacteristic {
  id: number;
  title: string;
  type: TProductCharacteristicType;
  values: IProductEntityCharacteristicItem[];
}

export interface IProductEntityCharacteristicItem {
  id: number;
  photo?: string;
  title: string;
  value: string;
}

export interface IProductEntityCharacteristicValue {
  id: number;
  label: string;
  value: string;
  characteristicId: number;
  characteristicTitle: string;
  characteristicType: TProductCharacteristicType;
}

export const EProductCharacteristicType = {
  COLOR: 'COLOR',
  IMAGE: 'IMAGE',
  TEXT: 'TEXT',
} as const;

export type TProductCharacteristicType = keyof typeof EProductCharacteristicType;
